/**
 *
 * @page 用户中心/我的方案/项目管理/方案详情 （协作）
 *
 **/
import React from 'react';
import { Tabs, Empty } from 'antd';
import BasePageWrap from '&/components/ResourceLib/BasePageWrap';
import SynergyTurbineTab from '@/components/UserCenter/SynergyTurbineTab';
// import ChangeHistoryTab from '@/components/UserCenter/ChangeHistoryTab';
import ProjectInfoTab from '&/components/ProjectSpace/ProjectInfoTab';
import ConstructionDrawing from '&/components/ConstructionDrawing/Project';
// import ScheduleProgressTab from '&/components/ProjectSpace/PlansProgress';//    v2.0施工进度
import ScheduleProgressTab from '@/components/UserCenter1.4/ScheduleProgressTab'; // v1.4施工进度
import ProjectPaymentTab from '&/components/ProjectSpace/ProjectPaymentTab';
import usePermission from '&/utils/customHooks/usePermission';
import { useHistory, useLocation } from 'react-router-dom';
import { SYNERGIA_TAB_STATUS } from '&/utils/baseMacro';
import { queryProductContent } from '@/api/personCenter/projectSpace1.4';
import './SchemeDetail.scss';

const { DRAWING, PLANS, INFO, MEMBERS, PAYMENT /* LOGS, BUDGET */ } =
    SYNERGIA_TAB_STATUS;

const SchemeDetail = props => {
    const { setBreadcrumb } = props;
    const location = useLocation();
    const history = useHistory();
    const [projectInfo, setProjectInfo] = useState({ houseType: [] });
    const [genreList, setGenreList] = useState([]);
    const SEARCH = new URLSearchParams(location.search);
    const projectId = SEARCH.get('id');
    const [payStatus, setPayStatus] = useState(location.state?.projectStatus);
    const [errorType, setErrorType] = useState(false);
    const [activeTab, setActiveTab] = useState({});
    const [tabs, setTabs] = useState([]);
    const TAB_NAME = SEARCH.get('tab');
    const TABS = [
        {
            name: intl.get('projectSpace.drawing'),
            key: DRAWING,
        },
        {
            name: intl.get('projectSpace.scheduleProgress'),
            key: PLANS,
        },
        {
            name: intl.get('projectSpace.fund'),
            key: PAYMENT,
        },
        {
            name: intl.get('projectSpace.projectInfo'),
            key: INFO,
        },
        // {
        //     name: intl.get('projectSpace.changeHistory'),
        //     key: LOGS,
        // },
        {
            name: intl.get('projectSpace.projectTurbine'),
            key: MEMBERS,
        },
        // {
        //     name: intl.get('projectSpace.budgetList'),
        //     key: BUDGET,
        // },
    ];
    const COMPONENTS = {
        [DRAWING]: <ConstructionDrawing info={projectInfo} />,
        [PLANS]: <ScheduleProgressTab />,
        [PAYMENT]: <ProjectPaymentTab />,
        [INFO]: (
            <ProjectInfoTab
                div="2"
                info={projectInfo}
                projectId={projectId}
                genreList={genreList}
                queryInfo={queryDetail}
            />
        ),
        [MEMBERS]: <SynergyTurbineTab />,
    };

    const [, , , refreshPermissions] = usePermission(projectId);

    useEffect(() => {
        refreshPermissions();
        queryDetail();
        return () => {
            // 清空面包屑
            setBreadcrumb('');
        };
    }, []);

    useEffect(() => {
        onStatusChange();
    }, [payStatus]);

    useEffect(() => {
        TAB_NAME && onChange(TAB_NAME);
    }, [TAB_NAME]);

    async function queryDetail() {
        await queryProductContent({ projectId }, 10001, 'SchemeDetail')
            .then(({ data }) => {
                setGenreList(data.genre);
                setProjectInfo(data.detail);
                setBreadcrumb(data.detail.name);
                setPayStatus(data.detail.status);
            })
            .catch(({ code }) => {
                code === 10001 && setErrorType(true);
            });
    }

    function onStatusChange() {
        // if (status < 0) history.push('/user-center/project-space');
        if (!payStatus) return;
        //   项目正常使用或者快到期  给显示全部的tab  否则只显示项目信息
        if (['1', '4', '5'].includes(payStatus)) {
            setTabs(TABS);
            onChange(TAB_NAME || DRAWING);
        } else {
            // 3 表示待支付
            onChange(INFO);
            setTabs([TABS[3]]);
        }
    }

    const onChange = key => {
        setActiveTab(TABS.find(el => el.key === key));

        if (TAB_NAME && TAB_NAME !== key) {
            location.search = '?id=' + SEARCH.get('id');
            history.replace(location.search);
        }
    };

    function targetPage({ target }) {
        const key = target.getAttribute('data-emitter');
        if (!key) return;
        const links = {
            home: '/home',
            resource: '/model-base/model-base-home',
            houseType: '/house-type/home',
        };
        history.push(links[key]);
    }

    const { TabPane } = Tabs;
    const EMPTY = (
        <div className="empty-project">
            <Empty
                image={require('@/assets/img/userCenter/jiesan.png').default}
                imageStyle={{
                    height: 191,
                }}
                description={
                    <>
                        <div className="result-message">
                            {intl.get('projectSpace.projectDisbanded')}
                        </div>
                        <div className="marketing-title">
                            {intl.get('projectSpace.uCan')}
                        </div>
                        <div className="marketing-item" onClick={targetPage}>
                            1、{intl.get('projectSpace.interview')}
                            <span className="native-link" data-emitter="home">
                                {intl.get('pages.home')}
                            </span>
                        </div>
                        <div className="marketing-item" onClick={targetPage}>
                            2、{intl.get('projectSpace.toOthers')}
                            <span
                                className="native-link"
                                data-emitter="resource">
                                {intl.get('userCenter.repository')}
                            </span>
                            、
                            <span
                                className="native-link"
                                data-emitter="houseType">
                                {intl.get('pages.houseTypeLibrary')}
                            </span>
                        </div>
                    </>
                }></Empty>
        </div>
    );

    return errorType ? (
        EMPTY
    ) : (
        <BasePageWrap
            className={
                activeTab.key === DRAWING
                    ? 'project-detail-con-draw project-detail'
                    : 'project-detail'
            }
            header={
                <Tabs
                    activeKey={activeTab.key}
                    onChange={onChange}
                    className="use-antd"
                    renderTabBar={(props, DefaultTabBar) => (
                        <DefaultTabBar {...props} className="use-antd-tab" />
                    )}>
                    {tabs.map(({ name, key }) => (
                        <TabPane tab={name} key={key}></TabPane>
                    ))}
                </Tabs>
            }
            type={'card'}>
            {COMPONENTS[activeTab.key]}
        </BasePageWrap>
    );
};

export default SchemeDetail;
